import { useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";
import { Home } from "./Pages/Home/Home";
import { About } from "./Pages/About/About";
import { NotFound } from "./Pages/NotFound/NotFound";
import AllNews from "./Pages/AllNews/AllNews";
import SingleNews from "./Pages/SingleNews/SingleNews";
import SuccessCases from "./Pages/SuccessCases/SuccessCases";
import SuccessCase from "./Pages/SuccessCase/SuccessCase";
import Contact from "./Pages/Contact/Contact";
import Soporte from "./Pages/Soporte/Soporte";
import CommonQuestions from "./Pages/CommonQuestions/CommonQuestions";
import Tutorials from "./Pages/Tutorials/Tutorials";
import IndustryEquipoPesado from "./Pages/IndustryEquipoPesado/IndustryEquipoPesado";
import IndustryManejoDeFlotas from "./Pages/IndustryManejoDeFlotas/IndustryManejoDeFlotas";
import IndustryFlotaMarina from "./Pages/IndustryFlotaMarina/IndustryFlotaMarina";
import IndustryDistribucion from "./Pages/IndustryDistribucion/IndustryDistribucion";
import IndustryConstruccion from "./Pages/IndustryConstruccion/IndustryConstruccion";
import IndustryTransporte from "./Pages/IndustryTransporte/IndustryTransporte";
import IndustryFuerzaLaboral from "./Pages/IndustryFuerzaLaboral/IndustryFuerzaLaboral";
import FamilyMyTracker from "./Pages/FamilyMyTracker/FamilyMyTracker";
import FamilyAutomoviles from "./Pages/FamilyAutomoviles/FamilyAutomoviles";
import FamilyBotes from "./Pages/FamilyBotes/FamilyBotes";
import FamilyMotocicletas from "./Pages/FamilyMotocicletas/FamilyMotocicletas";
import FamilyAdultosMayores from "./Pages/FamilyAdultosMayores/FamilyAdultosMayores";
import SolutionsG_Evolution from "./Pages/SolutionsG_Evolution/SolutionsG_Evolution";
import SolutionsAplicacionesMoviles from "./Pages/SolutionsAplicacionesMoviles/SolutionsAplicacionesMoviles";
import SolutionsServicios from "./Pages/SolutionsServicios/SolutionsServicios";
import SolutionsTelematica from "./Pages/SolutionsTelematica/SolutionsTelematica";
import AlliesNegocios from "./Pages/AlliesNegocios/AlliesNegocios";
import AlliesRevendedor from "./Pages/AlliesRevendedor/AlliesRevendedor";
import AlliesAlianzasClaves from "./Pages/AlliesAlianzasClaves/AlliesAlianzasClaves";
import AlliesUsuarioFinal from "./Pages/AlliesUsuarioFinal/AlliesUsuarioFinal";
import OportunidadesDeTrabajo from "./Pages/OportunidadesDeTrabajo/OportunidadesDeTrabajo";
import Postulaciones from "./Pages/Postulaciones/Postulaciones";

const AppRouter = () => {
	const [location] = useLocation();

	useEffect(() => {
		document.body.scrollIntoView({ block: "start", behavior: "smooth" });
	}, [location]);

	return (
		<>
			<Switch>
				<Route path="/" component={Home}></Route>
				<Route path="/acerca" component={About}></Route>
				<Route path="/noticias" component={AllNews}></Route>
				<Route path="/noticias/:id" component={SingleNews}></Route>
				<Route path="/carreras" component={OportunidadesDeTrabajo}></Route>
				<Route path="/carreras/:id" component={Postulaciones}></Route>
				<Route path="/casos-de-exito" component={SuccessCases}></Route>
				<Route path="/casos-de-exito/:id" component={SuccessCase}></Route>
				<Route path="/contacto" component={Contact}></Route>
				<Route path="/recursos/soporte" component={Soporte}></Route>
				<Route
					path="/recursos/preguntas-frecuentes"
					component={CommonQuestions}
				></Route>
				<Route path="/recursos/tutoriales" component={Tutorials}></Route>
				<Route
					path="/industry/equipo-pesado"
					component={IndustryEquipoPesado}
				></Route>
				<Route
					path="/industry/manejo-de-flotas"
					component={IndustryManejoDeFlotas}
				></Route>
				<Route
					path="/industry/flota-marina"
					component={IndustryFlotaMarina}
				></Route>
				<Route
					path="/industry/distribucion"
					component={IndustryDistribucion}
				></Route>
				<Route
					path="/industry/construccion"
					component={IndustryConstruccion}
				></Route>
				<Route
					path="/industry/transporte"
					component={IndustryTransporte}
				></Route>
				<Route
					path="/industry/fuerza-laboral"
					component={IndustryFuerzaLaboral}
				></Route>
				<Route path="/family/my-tracker" component={FamilyMyTracker}></Route>
				<Route path="/family/automoviles" component={FamilyAutomoviles}></Route>
				<Route path="/family/botes" component={FamilyBotes}></Route>
				<Route
					path="/family/motocicletas"
					component={FamilyMotocicletas}
				></Route>
				<Route
					path="/family/adultos-mayores"
					component={FamilyAdultosMayores}
				></Route>
				<Route
					path="/solutions/g-evolution"
					component={SolutionsG_Evolution}
				></Route>
				<Route
					path="/solutions/aplicaciones-moviles"
					component={SolutionsAplicacionesMoviles}
				></Route>
				<Route
					path="/solutions/servicios"
					component={SolutionsServicios}
				></Route>
				<Route
					path="/solutions/telematica"
					component={SolutionsTelematica}
				></Route>
				<Route path="/allies/negocios" component={AlliesNegocios}></Route>
				<Route path="/allies/revendedor" component={AlliesRevendedor}></Route>
				<Route
					path="/allies/alianzas-claves"
					component={AlliesAlianzasClaves}
				></Route>
				<Route
					path="/allies/usuario-final"
					component={AlliesUsuarioFinal}
				></Route>
				<Route component={NotFound}></Route>
			</Switch>
		</>
	);
};

export default AppRouter;
